import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverDocumentEntity } from '../../domain/entities/DriverDocumentEntity'
import type { DriverDocumentEtaDto } from '@/backend/market'
export class DriverDocumentModel extends DriverDocumentEntity {
  constructor(dataDto: DriverDocumentEtaDto) {
    super()
    mapEntityProperties<DriverDocumentEntity>(this, dataDto, {
      map: {
        documentType: dataDto.type
      }
    })
  }
}
